'use client';

import { ImageBj } from '@components/common';
import { cn } from '@utils/cn';
import bestieImage from '@images/bestie/bestie-avatar.png';

interface Props {
  className?: string;
}

const BestieAvatar = ({ className }:Props) => (
  <div className={cn('relative size-32 overflow-hidden rounded-full', className)}>
    <ImageBj
      priority
      src={bestieImage}
      alt="Bestie"
      className="size-full object-contain p-[8%]"
    />
  </div>
);

export default BestieAvatar;
